'use client'

import { defineStyleConfig, extendTheme, withDefaultColorScheme } from '@chakra-ui/react'
import merge from 'lodash/merge'
import appConfig from '#/src/appConfig'
import { baseTheme } from '#/src/custom/styles/theme.base'

const Checkbox = defineStyleConfig({
  defaultProps: {
    colorScheme: 'none'
  },
  baseStyle: {
    control: {
      _checked: {
        bg: 'primary'
      },
      _focus: {
        shadow: 'none'
      }
    }
  }
})

const Popover = defineStyleConfig({
  variants: {
    responsive: {
      popper: {
        maxWidth: {
          base: 'unset',
          md: '500px'
        }
      }
    }
  }
})

const Switch = defineStyleConfig({
  defaultProps: {
    colorScheme: 'gray'
  }
})

const Link = defineStyleConfig({
  baseStyle: {
    cursor: 'pointer'
  }
})

const Button = defineStyleConfig({
  baseStyle: {
    borderRadius: 'sm',
    color: 'text.light',
    fontWeight: 'medium',
    minW: 140,
    outlineOffset: 0,
    transition: 'all 0.35s cubic-bezier(.08,.52,.52,1)'
  },
  defaultProps: {
    size: 'md'
  }
})

const CustomFooter = defineStyleConfig({
  baseStyle: (props) => {
    const footerStyles = props.theme?.components?.CustomFooter || {}
    return {
      bg: 'background.surface',
      p: {
        base: 4,
        md: 10
      },
      ...footerStyles
    }
  }
})

export const defaultTheme = extendTheme(
  withDefaultColorScheme({
    colorScheme: 'customColorScheme'
  }),
  baseTheme,
  {
    components: {
      Checkbox,
      Popover,
      Switch,
      Link,
      Button,
      CustomFooter
    }
  }
)

export const customTheme = merge(defaultTheme, appConfig.theme)

/** Have to use function to get customTheme when updating appConfig dynamically */
export const getCustomTheme = () => merge(defaultTheme, appConfig.theme)
